<template>
  <permission-guard situation="site_design_configuration">
    <div>
      <h3>カスタムCSS設定</h3>
      <codemirror v-model="site.customCss" :options="cmOptions" class="my-5" />
    </div>

    <v-select
      v-model="site.designTemplateId"
      label="デザインテンプレート"
      style="width: 400px"
      :items="designTemplates"
      item-value="id"
      item-text="key"
    />
    <v-spacer />
    <v-alert dense outlined class="mt-5" type="error" style="width: 400px">
      <span class="caption"> 必ずデザイン崩れがないかを確認してください </span>
    </v-alert>
    <v-btn color="green darken-1" tile dark depressed @click="updateDesign">
      更新
    </v-btn>
  </permission-guard>
</template>

<script>
import axios from 'axios'
import PermissionGuard from '@/components/commons/PermissionGuard'

// language
import 'codemirror/mode/css/css.js'
// theme css
import 'codemirror/theme/monokai.css'

// require active-line.js
import 'codemirror/addon/selection/active-line.js'

// styleSelectedText
import 'codemirror/addon/selection/mark-selection.js'
import 'codemirror/addon/search/searchcursor.js'

// hint
import 'codemirror/addon/hint/show-hint.js'
import 'codemirror/addon/hint/show-hint.css'
import 'codemirror/addon/hint/css-hint.js'

// keyMap
import 'codemirror/mode/clike/clike.js'
import 'codemirror/addon/edit/matchbrackets.js'

export default {
  components: { PermissionGuard },
  props: {
    siteId: {
      type: Number,
      required: true
    }
  },
  data: () => {
    return {
      site: {},
      designTemplates: [],
      cmOptions: {
        mode: 'text/css',
        line: true,
        lineNumbers: true,
        collapseIdentical: false,
        highlightDifferences: true,
        matchBrackets: true,
        showCursorWhenSelecting: true,
        theme: 'monokai',
        hintOptions: {
          completeSingle: false
        }
      }
    }
  },
  mounted: function () {
    axios.get(`/api/sites/${this.siteId}/design/edit`).then(
      ({ data }) => {
        this.site = data.data.attributes
      },
      (error) => {
        const payload = {
          status: error.response.status,
          message: error.response.data.errors.toString()
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
      }
    )
    axios.get(`/api/design_templates`).then(
      ({ data }) => {
        data.forEach((d) => this.designTemplates.push(d.attributes))
      },
      (error) => {
        const payload = {
          status: error.response.status,
          message: error.response.data.errors.toString()
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
      }
    )
  },
  methods: {
    updateDesign () {
      const site = this.site
      const query = {
        site: {
          custom_css: site.customCss,
          design_template_id: site.designTemplateId
        }
      }
      axios.patch(`/api/sites/${site.id}/design`, query).then(
        () => {
          const payload = {
            status: 200,
            message: '変更を保存しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.errors.toString()
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    }
  }
}
</script>

<style scoped></style>
